import { gql } from "@apollo/client";

export const LOGIN_USER = gql`
  mutation Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      jwt
      user {
        id
        blocked
        username
        first_name
        second_name
        third_name
        fourth_name
        civil_id
        mobile_phone
        date_of_birth
        role {
          name
          type
        }
        center {
          id
          title_en
          title_ar
        }
      }
    }
  }
`;
